import React, { useRef, useCallback } from "react"

type CallbackType = (
  e: React.TouchEvent | React.MouseEvent
) => void

/** This hook handle mouse click and touch correctly. */
const useOnClickWithTouchHandler = (callback: CallbackType) => {

  const touchRef = useRef(null);

  // Handle touch start event
  const handleTouchStart = useCallback(
    (event: React.TouchEvent<HTMLElement | HTMLElement>) => {
      event.stopPropagation()
      // Store the initial touch coordinates and timestamp
      const touchStartX = event.touches[0].clientX;
      const touchStartY = event.touches[0].clientY;
  
      touchRef.current = {
        startX: touchStartX,
        startY: touchStartY,
        startTime: Date.now(),
      };

    },
    []
  )

  // Handle touch end event
  const handleTouchEnd = useCallback(
    (event: React.TouchEvent<HTMLElement | HTMLElement>) => {
      event.stopPropagation()

      // Calculate touch duration
      const touchEndTime = Date.now();
      const touchDuration = touchEndTime - touchRef.current.startTime;
  
      // Check if touch is quick and relatively stationary
      if (
        touchDuration < 300 &&
        Math.abs(event.changedTouches[0].clientX - touchRef.current.startX) < 10 &&
        Math.abs(event.changedTouches[0].clientY - touchRef.current.startY) < 10
      ) {
        callback && callback(event);
      }

    },
    [callback]
  )

  // Handle on click event
  const handleOnClick = useCallback(
    (
      event: React.MouseEvent<HTMLElement | HTMLElement, MouseEvent>
    ) => {
      callback && callback(event)
    },
    [callback]
  )

  return {
    onTouchStart: handleTouchStart,
    onTouchEnd: handleTouchEnd,
    onClick: handleOnClick
  }
}

export default useOnClickWithTouchHandler
